import { FC } from "react";
import * as _ from "lodash";

import { Alert, Menu, Dropdown, Button, LoadingOutlined } from "@ctra/components";
import { Enterprise as Content, useTranslation } from "@ctra/i18n";
import { FarmList } from "@ctra/api";
import { useGoogleAnalytics } from "@ctra/analytics";
import { useFarmList, useFarm } from "@farms";

import { GALabels, GAActions } from "../../../../analytics";
import styles from "./Callout.module.less";

interface CalloutProps {
  title: string;
  description: string;
}

/**
 * Callout with farm navigation dropdown
 * @param title
 * @param description
 * @constructor
 */
export const Callout: FC<CalloutProps> = ({ title, description }) => {
  const { t } = useTranslation();
  const { trackEvent } = useGoogleAnalytics();
  const { setFarmContext } = useFarm();
  const { farmList, isLoading } = useFarmList();

  const menu = (
    <Dropdown
      placement="bottomRight"
      trigger={["click"]}
      disabled={isLoading}
      dropdownRender={() => (
        <Menu
          onClick={({ key }) => {
            /* istanbul ignore next */
            trackEvent(GAActions.goToFarm, {
              label: _.defaultTo(farmList[key as unknown as keyof FarmList]?.name, void 0)
            });
            setFarmContext(key as unknown as number);
          }}
        >
          {_.map(farmList, ({ name, id }) => (
            <Menu.Item key={id}>{name}</Menu.Item>
          ))}
        </Menu>
      )}
    >
      <Button
        icon={isLoading ? <LoadingOutlined /> : null}
        // @ts-ignore
        onClick={() => trackEvent(GAActions.selectFarm, GALabels.goToFarm)}
      >
        {t<string>(Content.layouts.dashboard.callout.navigation)}
      </Button>
    </Dropdown>
  );

  return (
    <Alert
      className={styles.Alert}
      message={title}
      description={description}
      type="info"
      action={menu}
      showIcon
    />
  );
};
